import { render } from "./AdminMandators.vue?vue&type=template&id=281b9b6b&scoped=true"
import script from "./AdminMandators.vue?vue&type=script&lang=js"
export * from "./AdminMandators.vue?vue&type=script&lang=js"

import "./AdminMandators.vue?vue&type=style&index=0&id=281b9b6b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-281b9b6b"]])

export default __exports__